module.exports = __webpack_public_path__ + "ppt.png";